import React from 'react';
import type { FormatOptionLabel } from '../../common/types.tsx';
import AvatarOptionLabel from './avatar-option-label/index.tsx';
import IconOptionLabel from './icon-option-label/index.tsx';
import LozengeOptionLabel from './lozenge-option-label/index.tsx';

const formatOptionLabel: FormatOptionLabel = (data) => {
	switch (data.optionType) {
		case 'avatar':
			return <AvatarOptionLabel data={data} />;
		case 'lozenge':
			return <LozengeOptionLabel data={data} />;
		case 'option':
		case 'field':
			return <IconOptionLabel data={data} />;
		default:
			return null;
	}
};

export default formatOptionLabel;
